<aside class="sidebar-sec">
  <div class="sidelogoss">
    <a href="javascript:void(0)">
      <img
        src="\assets\images\logo_b.png"
        alt=""
        class="max_mg"
      />
    </a>

    <!-- <a href="javascript:void(0)">
      <img
        src="\assets\images\isolve_power.png"
        alt=""
        class="max_mg"
      />
    </a> -->

  </div>

  <!-- ============== Search ============ -->


  <div class="searchmenu">
    <div class="userlogs">
      <div class="user_names">
      <div class=""><img src="/assets/images/For_menu/Menu_Icons/log_user.png"></div>
      <div class="user_name_data" title="{{username.Technician_Name}}"> {{username}} </div>
      </div>

      <div class="user_stand">
        <div class=""><img src="/assets/images/For_menu/Menu_Icons/menu_stand_by.png" (click) = "logout()" ></div>
      </div>
   </div>

   <div class="">
    <input [formControl]="searchInput" [(ngModel)]="assignparamedic"
      class="form-control menuser"
      type="text"
      placeholder="Search" (keyup) = "searchTxt()"
    />
  <span class="menu_searchicon"
    ><i class="fa fa-search"></i
  ></span>
   </div>

</div>
<!-- ============== Search ============ -->

  <div class="sidebar-scroll">

    <ul class="sidebar-menu">
      <li
        class="main-menu has-collapsible"
        *ngFor="let parent of parentList"
        id="{{ parent.sidemenu.TARGETNAME }}"
      >
        <a
          *ngIf="!hasMenuChildren(parent)"
          (click)="setActive(parent.sidemenu.TARGETNAME)"
          [routerLink]="parent.sidemenu.URL ? parent.sidemenu.URL : null"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          ><span
            ><img
              src="/assets/images/For_menu/Menu_Icons/{{ parent.sidemenu.IMAGE }}"
              alt=""
              class="menu-img" /></span
          ><span>{{ parent.sidemenu.TARGETNAME }}</span></a
        >

        <a
          *ngIf="hasMenuChildren(parent)"
          (click)="setActive(parent.sidemenu.TARGETNAME)"
          ><span
            ><img
              src="/assets/images/For_menu/Menu_Icons/{{ parent.sidemenu.IMAGE }}"
              alt=""
              class="menu-img" /></span
          ><span class="arrowupdown">{{ parent.sidemenu.TARGETNAME }}</span></a
        >

        <ul class="sub-menu menu-child" *ngIf="hasMenuChildren(parent)">
          <li class="main-menu" *ngFor="let menu of menuChildren(parent)">
            <a
              routerLink="{{ menu.URL }}"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              ><span>{{ menu.TARGETNAME }}</span></a
            >
          </li>
        </ul>
      </li>

      <li class="main-menu rider-summary-menu-entry">
        <a
          routerLink="/weClean/reports/rider-summary-report"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span
            ><img
              src="/assets/images/For_menu/Menu_Icons/graph.png"
              alt=""
              class="menu-img"/></span>
          <span>Rider Summary</span>
        </a>
      </li>
      <!-- <li class="main-menu has-collapsible">
        <a routerLink="/weClean/dashboard" routerLinkActive="active"><span><img
              src="/assets/images/For_menu/Menu_Icons/dashboard.png" alt=""
              class="menu-img"></span><span>Dashboard</span></a>
      </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/orders.png" alt="" class="menu-img"></span><span
          class="arrowupdown">Orders</span></a>
          <ul class="sub-menu menu-child">
            <li class="main-menu">
              <a class="crts" routerLink="/weClean/order/newOrder" routerLinkActive="active"><span>New order</span></a>
            </li>
            <li class="main-menu">
              <a routerLink="/weClean/order/challans" routerLinkActive="active"><span>Challans</span></a>
            </li>
            <li class="main-menu">
              <a routerLink="/weClean/challan/update" routerLinkActive="active"><span>Processing</span></a>
            </li>
            <li class="main-menu">
              <a routerLink="/weClean/order/dispatch" routerLinkActive="active"><span>Disaptch</span></a>
            </li>
            <li class="main-menu">
              <a routerLink="/weClean/order/orderStatus" routerLinkActive="active"><span>Order Status</span></a>
            </li>
          </ul>
        </li>
        <li class="main-menu has-collapsible">
          <a class="crts" routerLink="/weClean/leads" routerLinkActive="active"><span><img
                src="/assets/images/For_menu/Menu_Icons/graph.png" alt=""
                class="menu-img"></span><span>Leads</span></a>
        </li>
        <li class="main-menu has-collapsible">
          <a class="crts" routerLink="/weClean/rider-availability" routerLinkActive="active"><span><img
                src="/assets/images/For_menu/Menu_Icons/graph.png" alt=""
                class="menu-img"></span><span>Rider Availability</span></a>
        </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/files.png" alt="" class="menu-img"></span><span
            class="arrowupdown">Invoices</span></a>
        <ul class="sub-menu menu-child">
          <li class="main-menu">
            <a routerLink="/weClean/invoice/manageInvoice" routerLinkActive="active"><span>Manage invoices</span></a>
            <a routerLink="/weClean/invoice/writrOff" routerLinkActive="active"><span>Write-Off</span></a>
            <a routerLink="/weClean/invoice/cashReceive" routerLinkActive="active"><span>Cash Receive</span></a>
            <a routerLink="/weClean/invoice/paymentStatus" routerLinkActive="active"><span>Payment Status</span></a>            
          </li>
        </ul>
      </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/alert.png" alt="" class="menu-img"></span><span
            class="arrowupdown">Complaints</span></a>
        <ul class="sub-menu menu-child">
          <li class="main-menu">
            <a routerLink="/weClean/complaints/complaints" routerLinkActive="active"><span>Complaints</span></a>
            <a routerLink="/weClean/complaints/refund" routerLinkActive="active"><span>Refund</span></a>
          </li>
        </ul>
      </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/files.png" alt="" class="menu-img"></span><span
            class="arrowupdown">Masters</span></a>
        <ul class="sub-menu menu-child">
          <li class="main-menu">
            <a routerLink="/weClean/masters/userManagement" routerLinkActive="active"><span>User management</span></a>
            <a routerLink="/weClean/masters/roleManagement" routerLinkActive="active"><span>Role management</span></a>
          </li>
        </ul>
      </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/files.png" alt="" class="menu-img"></span><span
            class="arrowupdown">Supplies</span></a>
        <ul class="sub-menu menu-child">
          <li class="main-menu">
            <a routerLink="/weClean/supplies/newPo" routerLinkActive="active"><span>New Po</span></a>
            <a routerLink="/weClean/supplies/receieveItems" routerLinkActive="active"><span>Receieve items</span></a>
            <a routerLink="/weClean/supplies/consume" routerLinkActive="active"><span>Consume</span></a>
          </li>
        </ul>
      </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/files.png" alt="" class="menu-img"></span><span
            class="arrowupdown">Offers</span></a>
        <ul class="sub-menu menu-child">
          <li class="main-menu">
            <a routerLink="/weClean/offers/createCoupon" routerLinkActive="active"><span>Create coupon</span></a>
            <a routerLink="/weClean/offers/couponConfig" routerLinkActive="active"><span>Coupon config</span></a>
            <a routerLink="/weClean/offers/manageCoupon" routerLinkActive="active"><span>Manage coupon</span></a>
          </li>
        </ul>
      </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/files.png" alt="" class="menu-img"></span><span
            class="arrowupdown">Riders</span></a>
        <ul class="sub-menu menu-child">
          <li class="main-menu">
            <a routerLink="/weClean/riders/newRider" routerLinkActive="active"><span>New rider</span></a>
            <a routerLink="/weClean/riders/manageRider" routerLinkActive="active"><span>Manage rider</span></a>
            <a routerLink="/weClean/riders/roster" routerLinkActive="active"><span>Roster</span></a>
            <a routerLink="/weClean/riders/trackRiders" routerLinkActive="active"><span>Track riders</span></a>
          </li>
        </ul>
      </li>
      <li class="main-menu has-collapsible">
        <a><span><img src="/assets/images/For_menu/Menu_Icons/files.png" alt="" class="menu-img"></span><span
            class="arrowupdown">Wallet</span></a>
        <ul class="sub-menu menu-child">
          <li class="main-menu">
            <a routerLink="/weClean/wallet/transactions" routerLinkActive="active"><span>Transactionsr</span></a>
            <a routerLink="/weClean/wallet/config" routerLinkActive="active"><span>Config</span></a>
          </li>
        </ul>
      </li> -->
     <!--  central -->

    </ul>
  </div>


  <!-- <div class="foot-text">

    <div class="userlogs">
       <div class="user_names">
       <div class=""><img src="/assets/images/For_menu/Menu_Icons/log_user.png"></div>
       <div class="user_name_data">Madhan Kumar</div>
       </div>

       <div class="user_stand">
         <div class=""><img src="/assets/images/For_menu/Menu_Icons/menu_stand_by.png"></div>
       </div>
    </div>
  </div> -->

</aside>
